import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app',
  template: `
  <div style="background-color: #fff;"></div>`,
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {


  constructor(private oauthService: OAuthService) { }

  ngOnInit() {
    const logout = sessionStorage.getItem('logout');
    if (logout === 'true') {
      this.logoff();
    } else {
      this.login();
    }
  }

  login() {
    sessionStorage.clear();
    this.oauthService.initCodeFlow();
  }

  logoff() {
    sessionStorage.clear();
    window.location.reload();
  }
}
